/**
 * "Events" tab of the device: reference transitions of this device
 */

import React, { useCallback } from 'react';
import { Paper, Typography } from '@mui/material';

import EventsList from '../EventsList';
import { referencesApi } from '../../services/referencesApi';

const PAGE_SIZE = 50;

const EventsTab: React.FC<{ deviceId: number }> = ({ deviceId }) => {
  const load = useCallback(
    (before?: string) => referencesApi.getDeviceEvents(deviceId, { limit: PAGE_SIZE, before }),
    [deviceId]
  );

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: 1, borderColor: 'divider' }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        Reference events
      </Typography>
      <EventsList load={load} pageSize={PAGE_SIZE} />
    </Paper>
  );
};

export default EventsTab;
